import { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";
import "@/Styles/Ticket.css";

type Props = {
  orderCode: string;
  width?: number;
  height?: number;
};

const styles = { maxWidth: "100%", height: "auto", zIndex: 1 };

export const BarcodeComponent = ({ orderCode, width, height }: Props) => {
  const barcodeRef = useRef<SVGSVGElement | null>(null);

  useEffect(() => {
    if (barcodeRef.current) {
      JsBarcode(barcodeRef.current, orderCode, {
        format: "CODE128",
        lineColor: "#000",
        width: width || 2,
        height: height || 100,
        displayValue: true,
        fontSize: 22,
      });
    }
  }, [orderCode, width, height]);

  return <svg ref={barcodeRef} style={styles} className="svgs"></svg>;
};
